import React, { useState } from 'react';
import { get } from 'lodash';
import moment from 'moment';
import axios from 'axios';
import Waypoint from 'react-waypoint';
import Loading from '../Loading';
import LinkText from '../LinkText';

const NFTEvolutionLogs = ({
  nftId
}) => {
  const [isLoading, setLoading] = useState(true)
  const [shouldFetch, setShouldFetch] = useState(true)
  const [logs, setLogs] = useState([])

  const fetchData = () => {
    if (shouldFetch) {
      axios.get(`/${gon.currentProvider}/api/nft/evolution_logs?nft_id=${nftId}`)
      .then((res) => {
        if (res.status == 200 && get(res, 'data.logs')) {
          setLogs(res.data.logs)
          setShouldFetch(false)
          setLoading(false)
        }
      })
    }
  }

  return (
    <React.Fragment>
      <div className='Container__header'>
        <h3 className='Container__header__h3'>Evolution</h3>
      </div>

      <Waypoint onEnter={fetchData}>
        <div className='Table Table--nft-evolution-logs'>
          <div className='Table__row'>
            <div className='Table__col Table__col--th'>ID</div>
            <div className='Table__col Table__col--th'>Bag id</div>
            <div className='Table__col Table__col--th'>Grade</div>
            <div className='Table__col Table__col--th'>Level</div>
            <div className='Table__col Table__col--th'>Cost</div>
            <div className='Table__col Table__col--th'>Created at</div>
          </div>

          <Loading
            isLoading={isLoading && logs.length == 0}
          >
            {logs.map((log) => (
              <div key={log.id} className='Table__row'>
                <div className='Table__col'>{log.id}</div>
                <div className='Table__col'><LinkText path={`bag/${log.bag_id}`} text={log.bag_id} /></div>
                <div className='Table__col'>{log.pal_grade}</div>
                <div className='Table__col'>{log.level}</div>
                <div className='Table__col'>{log.cost}</div>
                <div className='Table__col'>{moment(log.created_at).format('YYYY-MM-DD HH:mm')}</div>
              </div>
            ))}
            {logs.length == 0 && <div className='Table__row'>
              <div className='Table__col Table__col--span-3'>
                Nothing to show yet
              </div>
            </div>}
          </Loading>
        </div>
      </Waypoint>
    </React.Fragment>
  )
}

export default NFTEvolutionLogs
